import React, { } from 'react'
import { Grid } from '@mui/material'

import { useParams } from 'react-router-dom'

const MemorialScreen = () => {

    const { slug } = useParams()

    return (
        <>
            <div className='About_Container memorial_container container my-5'>

                <Grid container direction="column">
                    <Grid item>
                        <h3 style={{ textAlign: 'center', paddingTop: "10%" }}>
                            404 – Page Not Found
                        </h3>
                        <div style={{ textAlign: 'center', color: 'gray' }}>
                            Oops! It looks like you’ve landed on a page that doesn’t exist.
                        </div>
                        <div style={{ textAlign: 'center', paddingTop: "10px", color: 'gray' }}>
                            This page is only accessible through a valid QR code
                        </div>
                    </Grid>
                </Grid>
            </div>

        </>
    )
}

export default MemorialScreen
